import React from 'react';
import { Outlet, Route } from 'react-router-dom';
import LazyComponent from '@/components/LazyComponent';

const HomePage = React.lazy(() => import('@/pages/student/Home'));
const CoursesPage = React.lazy(() => import('@/pages/student/Courses'));
const CoursesDetailPage = React.lazy(
  () => import('@/pages/student/CourseDetail')
);
const AssignmentDetailPage = React.lazy(
  () => import('@/pages/student/AssignmentDetail')
);
const AnnouncementPage = React.lazy(
  () => import('@/pages/student/Announcement')
);
const NewLearningTrackerPage = React.lazy(
  () => import('@/pages/student/NewLearningTracker')
);
const SmartQuizPage = React.lazy(() => import('@/pages/student/SmartQuiz'));
const SmartQuizHistoryPage = React.lazy(
  () => import('@/pages/student/SmartQuizHistory')
);
const SmartQuizRecommendationsPage = React.lazy(
  () => import('@/pages/student/SmartQuizRecommendations')
);
const SmartQuizHistoryDetailPage = React.lazy(
  () => import('@/pages/student/SmartQuizHistoryDetail')
);
const SmartQuizDetailPage = React.lazy(
  () => import('@/pages/student/SmartQuizDetail')
);
const SmartQuizOverviewPage = React.lazy(
  () => import('@/pages/student/SmartQuizOverview')
);
const AiTutorPage = React.lazy(() => import('@/pages/student/AiTutor'));
const CommunitiesPage = React.lazy(() => import('@/pages/student/Communities'));
const CommunityPage = React.lazy(() => import('@/pages/student/Community'));
const CommunityDetailPage = React.lazy(
  () => import('@/pages/student/CommunityDetail')
);
const MessagesPage = React.lazy(() => import('@/pages/student/Messages'));
const SettingsPage = React.lazy(() => import('@/pages/student/Settings'));
const UnitDetailPage = React.lazy(() => import('@/pages/student/UnitDetail'));
const NewCoursePage = React.lazy(() => import('@/pages/student/NewCourse'));
const NewCourseGradesPage = React.lazy(
  () => import('@/pages/student/NewCourse/Grades')
);
const NewCourseAssignmentsPage = React.lazy(
  () => import('@/pages/student/NewCourse/Assignments')
);
const NewCourseAssignmentDetailPage = React.lazy(
  () => import('@/pages/student/NewCourse/Assignments/detail')
);
const NewCourseMembersPage = React.lazy(
  () => import('@/pages/student/NewCourse/Members')
);
const NewCourseAnnouncementsPage = React.lazy(
  () => import('@/pages/student/NewCourse/Announcements')
);
const NewCourseSyllabusPage = React.lazy(
  () => import('@/pages/student/NewCourse/Syllabus')
);
const NewCourseUnitsPage = React.lazy(
  () => import('@/pages/student/NewCourse/Units')
);
const NewCourseUnitDetailPage = React.lazy(
  () => import('@/pages/student/NewCourse/Units/detail')
);
const NewSmartQuizPage = React.lazy(
  () => import('@/pages/student/NewSmartQuiz')
);
const NewSmartQuizQuestionPage = React.lazy(
  () => import('@/pages/student/NewSmartQuiz/Question')
);
const NewSmartQuizDetailPage = React.lazy(
  () => import('@/pages/student/NewSmartQuiz/Detail')
);
const NewSmartQuizHistoryPage = React.lazy(
  () => import('@/pages/student/NewSmartQuiz/History')
);
const NewSmartQuizLearningRecommendationsPage = React.lazy(
  () => import('@/pages/student/NewSmartQuiz/LearningRecommendations')
);

function Index() {
  return (
    <Route path='student' element={<Outlet />}>
      <Route index element={<LazyComponent AsyncComponent={HomePage} />} />
      <Route path='courses' element={<Outlet />}>
        <Route index element={<LazyComponent AsyncComponent={CoursesPage} />} />
        <Route
          path=':courseId'
          element={<LazyComponent AsyncComponent={CoursesDetailPage} />}
        />
        <Route
          path=':courseId/assignment/:assignmentId'
          element={<LazyComponent AsyncComponent={AssignmentDetailPage} />}
        />
        <Route
          path=':courseId/announcement/:announcementId'
          element={<LazyComponent AsyncComponent={AnnouncementPage} />}
        />
        <Route
          path=':courseId/units/:unitId'
          element={<LazyComponent AsyncComponent={UnitDetailPage} />}
        />
      </Route>
      <Route path='new-course' element={<Outlet />}>
        <Route
          index
          element={<LazyComponent AsyncComponent={NewCoursePage} />}
        />
        <Route
          path='Units/detail'
          element={<LazyComponent AsyncComponent={NewCourseUnitDetailPage} />}
        />
        <Route
          path='Units'
          element={<LazyComponent AsyncComponent={NewCourseUnitsPage} />}
        />
        <Route
          path='Assignments'
          element={<LazyComponent AsyncComponent={NewCourseAssignmentsPage} />}
        />
        <Route
          path='Assignments/:assignmentId'
          element={
            <LazyComponent AsyncComponent={NewCourseAssignmentDetailPage} />
          }
        />
        <Route
          path='Grades'
          element={<LazyComponent AsyncComponent={NewCourseGradesPage} />}
        />
        <Route
          path='Members'
          element={<LazyComponent AsyncComponent={NewCourseMembersPage} />}
        />
        <Route
          path='Announcements'
          element={
            <LazyComponent AsyncComponent={NewCourseAnnouncementsPage} />
          }
        />
        <Route
          path='Syllabus'
          element={<LazyComponent AsyncComponent={NewCourseSyllabusPage} />}
        />
      </Route>
      <Route
        path='learning-tracker'
        element={<LazyComponent AsyncComponent={NewLearningTrackerPage} />}
      />
      <Route path='smart-quiz' element={<Outlet />}>
        <Route
          index
          element={<LazyComponent AsyncComponent={SmartQuizPage} />}
        />
        <Route
          path='history'
          element={<LazyComponent AsyncComponent={SmartQuizHistoryPage} />}
        />
        <Route
          path='learning-recommendations'
          element={
            <LazyComponent AsyncComponent={SmartQuizRecommendationsPage} />
          }
        />
        <Route
          path='history/:quizId'
          element={
            <LazyComponent AsyncComponent={SmartQuizHistoryDetailPage} />
          }
        />
        <Route
          path=':quizId'
          element={<LazyComponent AsyncComponent={SmartQuizDetailPage} />}
        />
        <Route
          path=':quizId/overview'
          element={<LazyComponent AsyncComponent={SmartQuizOverviewPage} />}
        />
      </Route>
      <Route path='new-smart-quiz' element={<Outlet />}>
        <Route
          index
          element={<LazyComponent AsyncComponent={NewSmartQuizPage} />}
        />
        <Route
          path='question'
          element={<LazyComponent AsyncComponent={NewSmartQuizQuestionPage} />}
        />
        <Route
          path='history'
          element={<LazyComponent AsyncComponent={NewSmartQuizHistoryPage} />}
        />
        <Route
          path='learning-recommendations'
          element={
            <LazyComponent
              AsyncComponent={NewSmartQuizLearningRecommendationsPage}
            />
          }
        />
        <Route
          path='detail'
          element={<LazyComponent AsyncComponent={NewSmartQuizDetailPage} />}
        />
      </Route>
      <Route
        path='ai-tutor'
        element={<LazyComponent AsyncComponent={AiTutorPage} />}
      />
      <Route path='communities' element={<Outlet />}>
        <Route
          index
          element={<LazyComponent AsyncComponent={CommunitiesPage} />}
        />
        <Route
          path=':communityId'
          element={<LazyComponent AsyncComponent={CommunityDetailPage} />}
        />
      </Route>
      <Route
        path='community/:communityId?'
        element={<LazyComponent AsyncComponent={CommunityPage} />}
      />
      <Route
        path='messages'
        element={<LazyComponent AsyncComponent={MessagesPage} />}
      />
      <Route
        path='settings'
        element={<LazyComponent AsyncComponent={SettingsPage} />}
      />
    </Route>
  );
}

export default Index;
